import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Navbar";
import Seo from "@/components/Seo";

function LegalLayout({ title, testid, seo, children }) {
  return (
    <div className="min-h-screen bg-[#faf8f5] text-[#0a192f]">
      {seo}
      <nav className="bg-[#faf8f5]/90 backdrop-blur-md border-b border-[#0b2545]/10 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" data-testid="legal-logo" className="flex items-center gap-3">
            <img src="/images/logo.png" alt="Dahmani Food" className="w-10 h-10 rounded-lg" />
            <div className="flex flex-col">
              <span className="font-display font-bold text-xl tracking-wide text-[#0b2545] leading-none">DAHMANI</span>
              <span className="text-[9px] uppercase tracking-[0.25em] text-[#c59b27] font-semibold mt-0.5">Food · Halal Ingrosso</span>
            </div>
          </Link>
          <Link to="/" data-testid="legal-back-home" className="text-xs font-semibold uppercase tracking-wider text-[#0b2545]/70 hover:text-[#0b2545] transition-colors">
            ← Torna al sito
          </Link>
        </div>
      </nav>
      <main data-testid={testid} className="max-w-3xl mx-auto px-6 py-16 space-y-8">
        <h1 className="font-display text-4xl md:text-5xl text-[#0b2545] font-normal">{title}</h1>
        <div className="space-y-6 text-sm leading-relaxed text-[#0b2545]/80">{children}</div>
      </main>
      <footer className="bg-[#06152d] text-white/60 py-8 text-center text-xs">
        © {new Date().getFullYear()} Dahmani Food srls. Tutti i diritti riservati.
      </footer>
    </div>
  );
}

const H = ({ children }) => <h2 className="font-display text-2xl text-[#0b2545] pt-4">{children}</h2>;

export function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" testid="privacy-page"
      seo={<Seo title="Privacy Policy | Dahmani Food" description="Informativa privacy di Dahmani Food srls: dati raccolti, finalità del trattamento e diritti dell'interessato." path="/privacy" />}>
      <p>Ultimo aggiornamento: gennaio 2026</p>
      <H>Titolare del trattamento</H>
      <p>
        Dahmani Food srls (di seguito "il Titolare"), P.IVA 11660540961, con sede legale in Via Lattanzio 60 — 20137
        Milano e magazzino operativo in Via Alessandro Volta, 15 — 20089 Rozzano (MI).
        Per qualsiasi richiesta relativa alla privacy puoi scrivere a{" "}
        <a href="mailto:hamid_dahmani@icloud.com" className="underline text-[#c59b27]">hamid_dahmani@icloud.com</a>.
      </p>
      <H>Dati raccolti</H>
      <p>
        Tramite il modulo contatti raccogliamo: nome e cognome, ragione sociale (facoltativa), indirizzo email, numero di
        telefono e contenuto del messaggio. I dati sono forniti volontariamente dall'utente.
      </p>
      <H>Finalità e base giuridica</H>
      <p>
        I dati sono trattati esclusivamente per rispondere alle richieste di informazioni o di fornitura inviate tramite il
        sito (esecuzione di misure precontrattuali, art. 6.1.b GDPR). Nessun dato viene ceduto a terzi né utilizzato per
        finalità di marketing senza consenso esplicito.
      </p>
      <H>Conservazione</H>
      <p>Le richieste di contatto sono conservate per il tempo necessario alla gestione della richiesta e comunque non oltre 24 mesi.</p>
      <H>Diritti dell'interessato</H>
      <p>
        Ai sensi degli artt. 15-22 GDPR puoi richiedere accesso, rettifica, cancellazione, limitazione e portabilità dei tuoi
        dati scrivendo all'indirizzo email del Titolare. Hai inoltre diritto di reclamo al Garante per la protezione dei dati
        personali.
      </p>
    </LegalLayout>
  );
}

export function CookiePolicyPage() {
  return (
    <LegalLayout title="Cookie Policy" testid="cookie-policy-page"
      seo={<Seo title="Cookie Policy | Dahmani Food" description="Cookie policy di Dahmani Food srls: questo sito utilizza solo cookie tecnici necessari al funzionamento." path="/cookie-policy" />}>
      <p>Ultimo aggiornamento: gennaio 2026</p>
      <H>Cosa sono i cookie</H>
      <p>
        I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati
        per essere ritrasmessi agli stessi siti alla visita successiva.
      </p>
      <H>Cookie utilizzati da questo sito</H>
      <p>
        Questo sito utilizza esclusivamente <strong>cookie tecnici</strong>, necessari al funzionamento (ad esempio per
        ricordare la preferenza espressa nel banner cookie). Non utilizziamo cookie di profilazione, analytics di terze parti
        né strumenti di tracciamento pubblicitario.
      </p>
      <H>Gestione delle preferenze</H>
      <p>
        Puoi eliminare o bloccare i cookie tecnici tramite le impostazioni del tuo browser; in tal caso alcune funzionalità
        del sito potrebbero non essere disponibili.
      </p>
    </LegalLayout>
  );
}
